'use client';

type TypographyAs = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div';
interface TypographyProps {
  as?: TypographyAs;
  className?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  dangerouslySetInnerHTML?: { __html: string };
  onMouseEnter?: React.MouseEventHandler<HTMLParagraphElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLParagraphElement>;
  onClick?: React.MouseEventHandler<HTMLParagraphElement>;
}

const Typography = ({ as = 'p', className, children, dangerouslySetInnerHTML, style, onMouseEnter, onMouseLeave, onClick }: TypographyProps) => {
  const Component = as;
  return (
    <Component className={className} style={style} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={onClick}>
      {dangerouslySetInnerHTML ? <span dangerouslySetInnerHTML={dangerouslySetInnerHTML} /> : children}
    </Component>
  );
};

export default Typography;
